import React from 'react'
import './Tbl.css'
import TblCell from './TblCell'

export default function TblHdr({cols}) {
  //TODO: Don't keep it here, the comparing to hard code 'Email' cell name...
  const colsComp = cols.map(col => <TblCell title={col} isWider={col === 'Email'} key={col}/>);

  return (
    <div className='tblHdr'>
        {colsComp}
    </div>
  )
}
